import { Component, OnInit, Input, ChangeDetectionStrategy, Inject, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
import { MobileNavigationService } from 'angular-engine/engine/service/ui/mobile-navigation/mobile-navigation.service';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';

@Component({
  selector: 'mobile-content-navigation',
  templateUrl: './mobile-content-navigation.template.html',
  styleUrls: ['./mobile-content-navigation.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileContentNavigation implements OnInit {
  @ViewChild('navigationContainer') navigationContainer : ElementRef;
  public isPhone: boolean = false;
  private changes: boolean = false;
  private windowWidth: number = 0;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private ngRouterSubject: Subject<void> = new Subject<void>();
  private navigationIndexObservable: Observable<number>;
  private _navigationElements:MobileNavigationItem[] = [];
  private set content(data:any){
    this._navigationElements = [];
    let activeItemSet:boolean = false;
    if(data && data.meta && data.meta.obj_type != "Section")
    {
        this._navigationElements.push({title: data.meta.title, active: true});
        activeItemSet = true;
    } 
    if(data && data.rows)
    {
        data.rows.forEach((rowItem) =>{
            let active:boolean = false;
            if(!activeItemSet)
            {
                active = true;
                activeItemSet = true;
            }
            this._navigationElements.push({title: rowItem.meta.title, active: active});
        })
    }
  };

  public get rowNavigation():MobileNavigationItem[]{
    return this._navigationElements;
  }

  constructor(@Inject(DEVICE_INFO) device: DeviceInfo,
  private mobileNavigationService: MobileNavigationService,
  protected route: ActivatedRoute,
  private cd: ChangeDetectorRef,
  protected coreEffects: CoreEffects
  ) { 
    this.isPhone = device.isPhone;
    this.windowWidth = mobileNavigationService.windowWidth;
  }

  ngOnInit() {
    this.mobileNavigationService.navigationSubject.takeUntil(this.ngUnsubscribe).subscribe((data) =>{
        this.content = data;
        this.cd.markForCheck();
    });
    
    this.mobileNavigationService.indexSubject.takeUntil(this.ngUnsubscribe).subscribe((index) =>{
        if(this._navigationElements && this._navigationElements.length)
        {
            let currentActive:MobileNavigationItem = this._navigationElements.find(item => item.active == true);
            currentActive.active = false;
    
            this._navigationElements[index].active = true;
            this.changes = true;
            this.cd.markForCheck();
        }
    });
  }

  ngAfterViewChecked() {
      if(this.changes)
      {
          this.changes = false;
          const el = this.navigationContainer.nativeElement.querySelector('span.active');
          this.navigationContainer.nativeElement.scrollLeft = el.offsetLeft - 15;
      }
  }

  ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
      this.ngUnsubscribe.unsubscribe();
  }

  clickNavItem(index:number){
    this.mobileNavigationService.index = index;
  }
  
}

interface MobileNavigationItem {
    title: string,
    active: boolean
  }



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/mobile-navigation/mobile-content-navigation.component.ts